import { render, staticRenderFns } from "./LmSpinnerBorder.vue?vue&type=template&id=e6cf6474&scoped=true"
var script = {}
import style0 from "./LmSpinnerBorder.vue?vue&type=style&index=0&id=e6cf6474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cf6474",
  null
  
)

export default component.exports